import { createFileRoute, redirect } from '@tanstack/react-router';

/** Redirect permanente: /dashboards (rota antiga) → /pipeline/dashboards (Bloco 1, DEC-060). */
export const Route = createFileRoute('/dashboards')({
  beforeLoad: () => {
    throw redirect({ to: '/pipeline/dashboards' });
  },
});
